import React, { useState, useMemo, useEffect, useCallback } from "react";
import { Typography } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import RiskOpportunityBuckets from "./components/RiskOpportunityBuckets/RiskOpportunityBuckets";
import PortfolioHealthScore from "./components/PortfolioHealthScore/PortfolioHealthScore";
import InventoryTableMock from "./components/InventoryTable/InventoryTableMock";
import { mockInventoryData } from "./mockInventoryData";
import { fetchPortfolioHealth } from "./services/api";
import styles from "./dealerInsights.module.css";
import "./DealerInsights.css";
import "../../styles/dashboardCardTokens.css";
import "../../styles/statusTokens.css";

const { Title } = Typography;

const BUCKET_PARAM = "bucket";
const VALID_BUCKETS = ["elite", "strong", "watch", "risk"];

function useBucketFilter() {
  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const bucket = params.get(BUCKET_PARAM);
  const bucketFilter = bucket && VALID_BUCKETS.includes(bucket.toLowerCase()) ? bucket.toLowerCase() : null;

  const setBucketFilter = useCallback(
    (nextBucket) => {
      const next = nextBucket && VALID_BUCKETS.includes(nextBucket.toLowerCase()) ? nextBucket.toLowerCase() : null;
      const same = next === bucketFilter;
      const newParams = new URLSearchParams(location.search);
      if (!next || same) {
        newParams.delete(BUCKET_PARAM);
      } else {
        newParams.set(BUCKET_PARAM, next);
      }
      const search = newParams.toString();
      history.replace({ pathname: location.pathname, search: search ? `?${search}` : "" });
    },
    [location.pathname, location.search, history, bucketFilter]
  );

  return [bucketFilter, setBucketFilter];
}

export default function DealerInsights() {
  const [vehicles] = useState(mockInventoryData);
  const [portfolioHealth, setPortfolioHealth] = useState(null);
  const [bucketFilter, setBucketFilter] = useBucketFilter();
  const filteredVehicles = useMemo(() => vehicles, [vehicles]);
  const bucketCounts = portfolioHealth?.bucket_counts ?? null;

  useEffect(() => {
    fetchPortfolioHealth()
      .then((data) => setPortfolioHealth(data))
      .catch(() => setPortfolioHealth(null));
  }, []);

  return (
    <div className="dashboard-content lot-performance-page" style={{ padding: '0 24px 12px', paddingLeft: '24px', position: 'relative', paddingTop: '24px', marginTop: '-60px', overflow: 'visible' }}>
      {/* Page Header with Title - hidden on mobile */}
      <div className="lot-performance-page-title" style={{ marginTop: '0px', marginBottom: '12px', paddingTop: '8px', paddingBottom: '8px', borderBottom: '1px solid rgba(255, 255, 255, 0.08)' }}>
        <Title
          level={1}
          style={{
            color: '#ffffff',
            marginBottom: 0,
            fontWeight: 700,
            fontSize: '20px',
            marginTop: 0,
            marginLeft: '0',
            paddingTop: 0,
            lineHeight: 1.3,
            overflow: 'visible'
          }}
        >
          Lot Performance
        </Title>
      </div>

      {/* Portfolio Health Score */}
      <PortfolioHealthScore vehicles={filteredVehicles} portfolioHealth={portfolioHealth} />

      {/* Main content */}
      <div className={styles.mainColumn}>
        {/* Inventory Performance Overview */}
        <RiskOpportunityBuckets
          vehicles={filteredVehicles}
          bucketCounts={bucketCounts}
          activeBucket={bucketFilter}
          onBucketClick={setBucketFilter}
        />

        {/* Your Inventory table */}
        <InventoryTableMock bucketFilter={bucketFilter} />
      </div>
    </div>
  );
}
